import logo from '@/imgs/logo.png'
import { isNativePlatform } from '@/lib/native'

export function MaintenanceScreen() {
  const title = isNativePlatform() ? 'האפליקציה בתחזוקה' : 'האתר בתחזוקה'
  return (
    <div dir='rtl' className='bg-background-app fixed inset-0 z-50 flex min-h-dvh w-full items-center justify-center p-6'>
      <div className='flex h-[600px] w-[300px] flex-col items-center justify-center gap-8 text-center'>
        <img src={logo} alt='logo' className='h-auto w-48' />
        <div className='flex flex-col gap-4'>
          <h1 className='text-2xl font-bold text-gray-900'>{title}</h1>
          <p className='text-lg text-gray-700'>אנחנו מבצעים תחזוקה שגרתית. נחזור בקרוב!</p>
        </div>
      </div>
    </div>
  )
}
